import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as sponsors from '../../sponsors'

export const RESOURCE = {
  payload: {
    description:
      'An entity, such as a federal agency or foundation, that provides funding, by an award, for research projects.',
    dimension: sponsors.RESOURCE.payload,
    level: 0,
    name: 'Sponsor',
    partialId: PartialId.Standard.create('sponsor'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
